// extracted by mini-css-extract-plugin
module.exports = {"container":"abr_e","heading":"abr_ce","subheading":"abr_cw","section":"abr_az","links":"abr_gm"};